import { render, staticRenderFns } from "./News-left.vue?vue&type=template&id=4d368a7b&scoped=true&"
import script from "./News-left.vue?vue&type=script&lang=js&"
export * from "./News-left.vue?vue&type=script&lang=js&"
import style0 from "./News-left.vue?vue&type=style&index=0&id=4d368a7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d368a7b",
  null
  
)

export default component.exports